// Never import any server-only code here, this is also used on the client side...
import type { TranslationsMap } from './types';

// Turkish version of the translation file
export const translations: TranslationsMap = {
  emails: {
    footer: {
      kindRegards: 'Saygılarımla,',
      questionsOrProblems: 'Sorularınız mı yoksa sorunlarınız mı var?',
      contactUs: 'Bize Ulaşın',
    },
    transportOrder: {
      confirm: 'Onaylamak',
      refuse: 'Reddetmek',
    },
    forgotPassword: {
      resetLink: 'Yeni şifreyi yapılandır',
    },
    userInvite: {
      view: 'Daveti görüntüle',
    },
    attachments: {
      quotation: 'Teklif {{reference}}',
    },
    customerComplaintAlert: {
      order: 'Siparişi görüntüle',
    },
  },
  truckDocumentType: {
    Insurance: 'Sigorta',
    Examination: 'Sınav',
  },
  orderDocumentType: {
    cmr: 'CMR',
    deliveryNote: 'Teslimat notu',
    weighSlip: 'Tartı fişi',
    palletNote: 'Palet fişi',
    annexII: 'Ek II',
    t1Document: 'T1 belgesi',
    annexVII: 'Ek VII',
    saleInvoice: 'Fatura',
    transportOrder: 'Taşıma siparişi',
    orderConfirmation: 'Sipariş onayı',
    sustainabilityReport: 'Sürdürülebilirlik raporu',
    customerAttachment: 'Müşteri eki',
    planning: 'Planlama',
    other: 'Diğer',
  },
  documentRejection: {
    subject: 'Belge {{orderNumber}} siparişi için reddedildi',
    intro: '{{orderNumber}} siparişi için aldığımız {{documentType}} dokümanını onaylayamadık. Sebepler:',
    outro:
      'Lütfen düzeltilmiş belgeyi normal kanalınız veya taşıyıcı portalı aracılığıyla yeniden gönderin. Teşekkür ederim!',
    MissingSignature: 'CMR üzerinde alıcının imzası eksik.',
    WrongCustomer: 'Belgedeki müşteri bu siparişin müşterisiyle eşleşmiyor.',
    WrongOrgOnDocument: 'Belgedeki iletici/gönderen kuruluşumuza uymuyor.',
    NoOrderReference: 'Bu belgeyi bir siparişe bağlayan geçerli bir sipariş veya fatura referansı bulamadık.',
    WrongDocumentType: 'Belge türü bu sipariş için beklediğimizle eşleşmiyor.',
    LowQuality:
      'Tarama/fotoğraf kalitesi, içeriği güvenilir bir şekilde doğrulamak için çok düşük. Lütfen daha yüksek kalitede bir kopyayı yeniden gönderin.',
  },
  trailerTypes: {
    BoxTrailer: 'Kutu Fragmanı',
    FlatBed: 'Düz yataklı',
    Mega: 'Mega Fragman',
    Refrigerated: 'Soğutmalı',
    RoadTrain: 'Karayolu Treni',
    Tautliner: 'Tautliner',
    Joloda: 'Tautliner / Joloda',
    TautlinerCoil: 'Tautliner / Bobin',
  },
  loadingMethods: {
    Back: 'Geri',
    Side: 'Taraf',
    Top: 'Çatı yoluyla',
  },
  documents: {
    note: {
      extraInformation: 'Ekstra bilgi',
    },
    letter: {
      letter: 'Mektup',
    },
    paymentReminder: {
      invoiceNumber: 'Fatura numarası',
      invoiceDate: 'Fatura tarihi',
      dueDate: 'Bitiş tarihi',
      amount: 'Miktar',
      expiredAmount: 'Süresi dolmuş tutar',
      currency: 'Para birimi',
      totalOutstanding: 'Total outstanding',
      salutation: 'Dear Sir or Madam,',
      subject: {
        first: 'Subject: payment reminder — {{reference}}',
        second: 'Subject: second payment reminder — {{reference}}',
        third: 'Subject: third payment reminder — {{reference}}',
        final: 'Subject: notice of default — {{reference}}',
      },
      intro: {
        first:
          'Our records show that the invoices below have not yet been settled. If your payment has crossed with this letter, please disregard it.',
        second: 'Despite our earlier reminder, we have not yet received payment for the invoices below:',
        third: 'Despite repeated reminders, the invoices below are still outstanding:',
        final: 'Despite earlier payment reminders, we have to date received no payment for the invoices below:',
      },
      request:
        'We request that you transfer the outstanding amount of {{amount}} to the account below within {{days}} calendar days of receiving this letter, quoting the reference:',
      acknowledgement:
        'If you do not pay and do not state a reason for this, it will be regarded as an acknowledgement of the debt.',
      escalation: {
        first: 'Should we not receive your payment within this period, we will send you a further reminder.',
        second: 'Should we not receive your payment within this period, we will be obliged to escalate this file.',
        third:
          'Should payment not be made within this period, this file will be transferred to our debt collection procedure.',
        final:
          'Should payment not be made within this period, we will hand this file to our legal counsel without further notice, with instructions to start legal proceedings against you. The costs of this will be entirely at your expense.',
      },
      closing: {
        first: 'We trust you will settle the outstanding amount within the requested period.',
        second: 'We trust you will settle the outstanding amount within the requested period.',
        third: 'We trust you will settle the outstanding amount within the requested period.',
        final:
          'We trust this will not be necessary and that you will settle the outstanding amount within the requested period.',
      },
      sincerely: 'Sincerely,',
      signature: 'Accounting {{company}}',
      account: 'Account {{company}}',
      accounts: '{{company}} hesapları',
      reference: 'Reference',
      amountDue: 'Amount due',
      bic: 'BIC',
      heldBy: 'hesap sahibi {{company}}',
      date: 'Date',
      ourReference: 'Our reference',
      customerNumber: 'Customer number',
      yourVatNumber: 'Your VAT number',
      contact: 'Contact',
      phone: 'Phone',
    },
    quotation: {
      quotation: 'Alıntı yapmak',
      customerNumber: 'Müşteri numarası',
      reference: 'Referans',
      date: 'Teklif tarihi',
      dueDate: 'Son kullanma tarihi',
      from: 'İtibaren',
      to: 'İle',
      volume: 'Hacim',
      price: 'Fiyat',
      generalTermsAndConditions: 'Genel satış koşulları ektedir',
      questionsOrComments: 'Sorularınız için {{email}} adresinden e-posta yoluyla bize ulaşın',
      trailerTypes: 'Treyler türleri',
    },
    transportOrder: {
      trailerTypes: 'Römork Çeşitleri',
      loadingMethod: 'Yükleme Yöntemi',
      transportOrder: 'Taşıma Sırası',
      date: 'Tarih',
      orderRef: 'Sipariş Referansı',
      load: 'Yük',
      unload: 'Boşalt',
      reference: 'Referans',
      goods: 'Mal',
      description: 'Tanım',
      packageType: 'Palet tipi',
      palletCount: 'Paletler',
      weight: 'Ağırlık',
      LoadingMeter: 'Yük ölçer',
      freightRate: 'Navlun oranı',
      price: 'Fiyat',
      vat: 'KDV',
      questionsOrComments: 'Sorularınız veya yorumlarınız mı var?',
      contactFileManager: 'Dosya yöneticinizle iletişime geçmekten çekinmeyin',
      anonymousCmr: 'BU SİPARİŞ İÇİN ANONİM CMR OLUŞTURULMASI ZORUNLUDUR.',
      phone: 'Telefon',
      email: 'E-posta',
    },
    planning: {
      planning: 'Planlama',
      licensePlate: 'Plaka',
      codeName: 'Kod adı',
    },
    kilometers: {
      full: 'Yüklü kilometre',
      empty: 'Boş kilometre',
      total: 'Toplam kilometre',
      planningTotal: 'Bu planlamanın toplamı',
    },
    orderConfirmation: {
      orderConfirmation: 'Sipariş Onayı',
      dearCustomer: 'Sayın Müşteri,',
      herebyWeConfirmYourOrder: 'Aşağıdaki taşıma için siparişinizi onaylıyoruz:',
      date: 'Tarih',
      ourReference: 'Referansımız',
      yourReference: 'Referansınız',
      load: 'Yük',
      unload: 'Boşalt',
      reference: 'Referans',
      goods: 'Mal',
      description: 'Tanım',
      packageType: 'Palet tipi',
      palletCount: 'Paletler',
      weight: 'Ağırlık',
      LoadingMeter: 'Yük ölçer',
      freightRate: 'Navlun oranı',
      price: 'Fiyat',
      vat: 'KDV',
      questionsOrComments: 'Sorularınız veya yorumlarınız mı var?',
      contactFileManager: 'Dosya yöneticinizle iletişime geçmekten çekinmeyin',
      phone: 'Telefon',
      email: 'E-posta',
    },
    orderCancellation: {
      orderCancellation: 'Sipariş iptali',
      dearCustomer: 'Sayın Müşteri,',
      orderCancelledText: 'Aşağıdaki nakliyeye ilişkin siparişiniz iptal edilmiştir:',
      date: 'Tarih',
      ourReference: 'Referansımız',
      yourReference: 'Referansınız',
      load: 'Yük',
      unload: 'Boşalt',
      reference: 'Referans',
      goods: 'Mal',
      description: 'Tanım',
      packageType: 'Palet tipi',
      palletCount: 'Paletler',
      weight: 'Ağırlık',
      LoadingMeter: 'Yük ölçer',
      freightRate: 'Navlun oranı',
      price: 'Fiyat',
      vat: 'KDV',
      questionsOrComments: 'Sorularınız veya yorumlarınız mı var?',
      contactFileManager: 'Dosya yöneticinizle iletişime geçmekten çekinmeyin',
      phone: 'Telefon',
      email: 'E-posta',
    },
    invoice: {
      invoice: 'Fatura',
      customerNumber: 'Müşteri numarası',
      invoiceNumber: 'Fatura numarası',
      invoiceDate: 'Fatura tarihi',
      dueDate: 'Bitiş tarihi',
      load: 'Yük',
      unload: 'Boşalt',
      ourReference: 'Referansımız',
      yourReference: 'Referansınız',
      description: 'Tanım',
      quantity: 'Miktar',
      unitPrice: 'Birim fiyat',
      total: 'Toplam',
      vat: 'KDV',
      paymentInformation: 'Ödeme Bilgileri',
      amountToPay: 'Ödenecek tutar',
      toBePaidBefore: 'Daha önce ödenecek',
      beneficiary: 'Yararlanıcı',
      message: 'Mesaj',
      generalTermsAndConditions: 'Genel satış koşulları ektedir',
      questionsOrComments: 'Sorularınız için lütfen {{email}} adresinden muhasebeyle iletişime geçin.',
    },
    sustainabilityReport: {
      sustainabilityReport: 'Sürdürülebilirlik Raporu',
      date: 'Tarih',
      ourReference: 'Referansımız',
      yourReference: 'Referansınız',
      truck: 'Kamyon',
      distance: 'Mesafe',
      weight: 'Ağırlık',
      emissions: 'Emisyonlar',
      questionsOrComments: 'Sorular mı yoksa açıklamalar mı?',
      contactFileManager: 'Dosya yöneticinizle iletişime geçmekten çekinmeyin',
      phone: 'Telefon',
      email: 'E-posta',
    },
    globalSustainabilityReport: {
      sustainabilityReport: 'Sürdürülebilirlik Raporu',
      date: 'Tarih',
      startDate: 'Başlangıç ​​tarihi',
      endDate: 'Bitiş tarihi',
      orderCount: 'Sipariş Sayısı',
      truck: 'Kamyon',
      totals: 'Toplam',
      distance: 'Mesafe',
      weight: 'Ağırlık',
      emissions: 'CO2 emisyonları',
      averagePerOrder: 'Sipariş başına ortalama',
      framework:
        'Emisyon hesaplamasıyla ilgili ayrıntılar için lütfen web sitemizdeki sürdürülebilirlik politikasını inceleyin.',
      questionsOrComments: 'Sorularınız veya yorumlarınız mı var?',
      contactFileManager: 'Dosya yöneticinizle iletişime geçmekten çekinmeyin',
      phone: 'Tel.',
      email: 'E-posta',
    },
    rideOverview: {
      title: 'Özet',
      entryNumber: 'Özet referansı',
      dossier: 'Dosya',
      draftBanner: 'Taslak – henüz onaylanmadı',
      invoiceRequestNotice:
        'Bu belge geçerli bir self-billing faturası değildir. Bu özeti aldıktan sonra {{customer}} bu siparişler için sizden bir fatura bekler.',
    },
    selfBill: {
      title: 'Self-billing faturası',
      number: 'No.',
      draftBanner: 'Taslak – henüz onaylanmadı',
      supplierLabel: 'Tedarikçi — taşıyıcı · bu şirkete ödeme yapıyoruz',
      customerLabel: 'Müşteri — bu faturayı tedarikçi adına düzenler',
      vatCompanyNumber: 'KDV / şirket no.:',
      vatShort: 'KDV',
      carrierNumber: 'Taşıyıcı numarası: {{number}}',
      customerRegister: 'RLE Gent, division Kortrijk',
      bankLabel: 'Tedarikçinin banka hesabına ödeme',
      bankNotice:
        'Taşıyıcı dosyamızda kayıtlıdır. Bu hesap size ait değilse hemen {{email}} ile iletişime geçin. Banka bilgileri yalnızca doğrulama prosedürümüzle değiştirilir, asla bir e-posta talebine dayanarak değiştirilmez.',
      documentType: 'Belge türü',
      invoiceNumber: 'Fatura numarası',
      invoiceDate: 'Fatura tarihi',
      servicePeriod: 'Hizmet dönemi',
      agreement: 'Sözleşme',
      paymentDate: 'Ödeme tarihi',
      natureOfServices:
        'Hizmetlerin niteliği: {{nature}}, satır başına bir sefer, belirtilen sevkiyat tarihinde gerçekleştirilmiştir. Birim fiyat = satır tutarı (miktar 1), KDV hariç.',
      roadFreightTransport: 'karayolu yük taşımacılığı',
      columnNumber: 'No.',
      columnFile: 'Dosya',
      columnShipmentDate: 'Sevkiyat tarihi',
      columnLoading: 'Yükleme',
      columnUnloading: 'Boşaltma',
      columnQuantity: 'Adet',
      columnVat: 'KDV',
      columnAmount: 'EUR',
      tripCountOne: 'Bu faturadaki sefer sayısı: 1',
      tripCountOther: 'Bu faturadaki sefer sayısı: {{count}}',
      totalServices: 'Toplam taşıma hizmetleri (KDV hariç)',
      earlyPaymentDiscount: 'Erken ödeme indirimi {{percentage}}',
      earlyPaymentCondition:
        '7 gün içinde ödemede {{percentage}} ({{amount}}) indirim düşülür. Ödenecek: {{withDiscount}}. Bu süreden sonra: {{withoutDiscount}}.',
      taxableAmount: 'Matrah ({{rate}})',
      vat: 'KDV {{rate}}',
      totalToPay: 'Ödenecek toplam',
      paymentNotice:
        '{{amount}}, {{date}} tarihinde otomatik olarak {{iban}} hesabına aktarılacaktır. Herhangi bir işlem yapmanıza gerek yoktur.',
      paymentNoticeWithoutAccount:
        '{{amount}}, {{date}} tarihinde otomatik olarak aktarılacaktır. Herhangi bir işlem yapmanıza gerek yoktur.',
      yourInvoiceTitle: 'Bu sizin faturanızdır. Lütfen bu seferler için bize fatura göndermeyin.',
      yourInvoice:
        'Bu belge, iki taraf arasındaki self-billing sözleşmesi kapsamında {{customer}} tarafından {{supplier}} adına ve hesabına düzenlenmiştir. Bir teklif değildir. Aynı seferler için kendinizin göndereceği fatura mükerrer olarak reddedilecektir.',
      acceptanceTitle: 'Kabul',
      acceptance:
        'Bu fatura, fatura tarihinden itibaren 7 gün içinde {{email}} adresine yazılı olarak itiraz edilmedikçe tedarikçi tarafından kabul edilmiş sayılır. Düzeltmeler self-billing alacak dekontu ile yapılır.',
      paymentTermTitle: 'Ödeme vadesi',
      paymentTerm: 'Ödeme vadesi sözleşmenizde kararlaştırılan vadedir. İndirim uygulandıysa ödeme vadesi 7 gündür.',
      missingTripTitle: 'Eksik bir sefer mi var?',
      missingTrip:
        'Belgeleri eksik olduğu için bir sefer bu faturada yer almıyor. Doğru belgeleri taşıyıcı portalına yükleyin; sefer bir sonraki self-billing faturanıza eklenecektir.',
      questionsTitle: 'Sorularınız mı var?',
      questions: 'Fatura numarasını belirterek {{email}} adresine yazın.',
      legalSelfBilling: 'Self-billing',
      legalNotice:
        '{{selfBilling}} — fatura, alıcı tarafından tedarikçi adına ve hesabına düzenlenmiştir (2006/112/AT sayılı Direktif md. 224 ve 226 (10a)) · Self-billing sözleşmesi {{agreement}} · Peppol BIS Self-Billing 3.0, belge türü 389',
      legalTerms:
        'Genel satış koşulları ektedir ve {{website}} adresinde mevcuttur · Belçika hukuku uygulanır · Yetkili mahkeme Kortrijk mahkemeleridir',
      pageFooter: '{{title}} {{number}} · {{company}}',
      page: 'Sayfa {{page}} / {{total}}',
    },
    creditNote: {
      creditNote: 'Kredi notu',
      customerNumber: 'Müşteri numarası',
      creditNoteNumber: 'Kredi notu numarası',
      date: 'Tarih',
      dueDate: 'Bitiş tarihi',
      load: 'Yük',
      unload: 'Boşalt',
      ourReference: 'Referansımız',
      yourReference: 'Referansınız',
      description: 'Tanım',
      quantity: 'Miktar',
      unitPrice: 'Birim fiyat',
      total: 'Toplam',
      vat: 'KDV',
      paymentInformation: 'Ödeme Bilgileri',
      amountToPay: 'Ödenecek tutar',
      toBePaidBefore: 'Daha önce ödenecek',
      payer: 'Ödeyen',
      message: 'Mesaj',
      generalTermsAndConditions: 'Genel satış koşulları ektedir',
      questionsOrComments: 'Sorularınız için lütfen {{email}} adresinden muhasebeyle iletişime geçin.',
    },
    carrierTruckReport: {
      title: 'Kamyon performans raporu',
      truckname: 'İsim',
      totalIncome: 'Toplam gelir',
      totalKm: 'Toplam kilometre',
    },
    totals: {
      totalExclVat: 'Toplam hariç KDV',
      totalVat: 'Toplam KDV',
      totalInclVat: 'Toplam dahil. KDV',
      cashDiscount: 'Erken ödeme indirimi',
      netAmountToPay: 'Ödenecek net tutar',
      vatReverseCharged: 'KDV Ters Ücreti, KDV Direktifi madde 44',
    },
  },
  carrierTerms: {
    agreement: 'Öz faturalandırma prosedürü dahil olmak üzere {{terms}} kabul ediyorum.',
    termsLink: 'genel koşulları',
  },
  pages: {
    confirmOrderStates: {
      headingRefused: 'Sipariş reddedildi',
      headingCancelled: 'Sipariş iptal edildi',
      headingConfirmed: 'Sipariş onaylandı',
      headingUnknownStatus: 'Sipariş zaten yürütüldü veya durum bilinmiyor',
    },
    confirmOrderPlanningStates: {
      headingRefused: 'Planlama reddedildi',
      headingCancelled: 'Planlama iptal edildi',
      headingConfirmed: 'Planlama onaylandı',
      headingUnknownStatus: 'Planlama zaten yürütüldü veya durum bilinmiyor',
    },
    confirmOrder: {
      heading: 'Taşıma siparişini onaylayın {{order.orderNumber}}',
      orderConfirmed: 'Sipariş onaylandı',
      orderConfirmationError: 'Sipariş onaylanamadı: {{error}}',
      confirmButton: `Taşıma siparişini onaylayın`,
    },
    confirmPlanning: {
      heading: 'Planlamayı onaylayın {{planningDate}}',
      planningConfirmed: 'Planlama onaylandı',
      confirmButton: `Planlamayı onaylayın`,
    },
    refuseOrder: {
      heading: 'Taşıma emrini reddet {{order.orderNumber}}',
      orderRefused: 'Sipariş reddedildi',
      orderRefusalError: 'Sipariş reddedilemedi: {{error}}',
      refuseButton: `Taşıma emrini reddet`,
    },
    refusePlanning: {
      heading: 'Planlamayı reddet {{planningDate}}',
      planningRefused: 'Planlama reddedildi',
      refuseButton: `Planlamayı reddet`,
    },
    orderSummary: {
      loadAndUnloadInformation: 'Bilgileri yükleme ve kaldırma',
      load: 'Yük',
      unload: 'Boşalt',
      freightRate: 'Navlun oranı',
      total: 'Toplam',
    },
  },
  portal: {
    requestAccount: {
      requestCustomerAccount: 'Müşteri olarak hesap talep edin',
      requestCarrierAccount: 'Taşıyıcı olarak hesap talep edin',
      success: 'Talep gönderildi, daha sonraki adımlar için sizinle iletişime geçeceğiz.',
      failed: 'Hesap isteğinde bulunulamadı: {{error}}',
      name: 'İsim',
      email: 'E-posta',
      companyName: 'Firma Adı',
      companyNumber: 'Şirket Numarası', // Or 'Business Registration Number' depending on context
      request: 'Rica etmek',
      dontHaveAnAccount: 'Henüz hesabınız yok mu?',
      accountRequestFailed: 'Hesap talebi başarısız oldu',
    },
  },
  customerPortal: {
    switch: 'Müşteriyi Değiştir',
    selectCustomer: 'Müşteri seçin',
    requestAccount: {
      title: 'Hesap talep et',
      success: 'Talep gönderildi. Daha sonraki adımlar için sizinle iletişime geçeceğiz.',
      failed: 'Hesap isteğinde bulunulamadı: {{error}}',
      name: 'İsim',
      email: 'E-posta',
      companyName: 'Firma Adı',
      companyNumber: 'Şirket Numarası',
      request: 'Rica etmek',
      dontHaveAnAccount: 'Henüz hesabınız yok mu?',
    },
    invite: {
      title: 'Müşteri Portalına Davet Edildi',
      details: 'TransDirect müşteri portalına davet edildiniz, şifrenizi girerek hesabınızı oluşturun.',
      accepted: 'Davet kabul edildi, kısa süre içinde ana sayfaya yönlendirileceksiniz.',
      acceptError: 'Davet kabul edilemedi: {{error}}',
      acceptButtonText: 'Daveti Kabul Et',
      password: 'Şifre',
      repeatPassword: 'Şifreyi tekrar girin',
    },
    home: {
      customerPortal: 'Müşteri portalı',
      title: 'Müşteri portalı',
      hello: 'Merhaba,',
      welcome: 'Müşteri portalına hoş geldiniz.',
      manageOrders: 'Tüm taşıma siparişlerinizi yönetin.',
      viewInvoices: 'Faturaları kolayca görüntüleyin ve ödeyin.',
      createQuotes: 'Teklifler oluşturun ve izleyin.',
      viewLocations: 'Tüm taşıma konumlarını görüntüleyin.',
    },
    locations: {
      locations: 'Konumlar',
      location: 'Konum',
      name: 'İsim',
      street: 'Sokak',
      number: 'Sayı',
      countryCode: 'Ülke kodu',
      postalCode: 'Posta Kodu',
      city: 'Şehir',
      country: 'Ülke',
      language: 'Dil',
      notes: 'Notlar',
      createLocation: 'Konum Oluştur',
      newLocation: 'Yeni Konum',
      locationCreated: 'Konum oluşturuldu',
      couldNotCreateLocation: 'Konum oluşturulamadı: {{error}}',
      findLocation: 'Bir konum bulun...',
      address: 'Adres',
      locationNotFound: 'Konum bulunamadı',
      couldNotLoadLocation: 'Konum yüklenemedi: {{error}}',
    },
    order: {
      duplicate: 'Kopyalamak',
      bulkDuplicate: 'Toplu kopya',
      bulkDuplicateTitle: 'Toplu yinelenen sipariş',
      bulkDuplicateDescription: 'Artan fatura referanslarıyla bu siparişin birden çok kopyasını oluşturun.',
      numberOfDuplicates: 'Kopya sayısı',
      baseInvoiceRef: 'Fatura referansı başlatılıyor',
      baseInvoiceRefHelper:
        'Sayısal taban. Baştaki sıfırlar çıkarılır. Referanslar base+count-1 aracılığıyla temel haline gelir.',
      skipDraft: 'Taslak durumunu atla (Oluşturuldu olarak oluştur)',
      bulkDuplicateSuccess: '{{count}} siparişler oluşturuldu',
      bulkDuplicateError: 'Siparişler kopyalanamadı: {{error}}',
      referencePreview: 'Referanslar: {{first}} ila {{last}} arası',
      overview: 'Genel Bakış',
      updateInvoiceRef: 'Fatura referansını güncelle',
      updated: 'Sipariş güncellendi',
      couldNotUpdate: 'Sipariş güncellenemedi: {{error}}',
    },
    orders: {
      orders: 'Siparişler',
      placeOrder: 'Sipariş ver',
      invoiceRef: 'Fatura referansı',
      orderRef: 'Sipariş referansı',
      loadLocation: 'Konumu yükle',
      unloadLocation: 'Konumu boşalt',
      loadDate: 'Yükleme tarihi',
      loadTime: 'Yükleme süresi',
      unloadDate: 'Kaldırma tarihi',
      unloadTime: 'Boşaltma süresi',
      invoiceTotal: 'Fatura toplamı',
      status: 'Durum',
      invoiceStatus: 'Fatura durumu',
      hasCMR: "CMR'si var",
      creationDate: 'Oluşturulma tarihi',
      executionDate: 'Yürütme tarihi',
      fileManager: 'Dosya yöneticisi',
      cancellationReason: 'İptal nedeni',
      stops: 'Duraklar',
      deleteStop: 'Durağı sil',
      purchases: 'Satın almalar',
      total: 'Toplam',
      trailerTypes: 'Treyler türleri',
      loadingMethod: 'Yükleme Yöntemi',
      load: 'Yük',
      unload: 'Boşalt',
      typeStop: 'Durak tipi',
      extraNotes: 'Ekstra notlar',
      noContent: 'İçerik yok',
      packaging: 'Ambalajlama',
      coli: 'Koli',
      content: 'İçerik',
      addContent: 'İçerik ekle',
      deleteContent: 'İçeriği sil',
      noStops: 'Duraklama yok',
      noStopsError: 'En az bir yükleme ve boşaltma durağı ekleyin',
      reference: 'Referans',
      complaints: 'Şikayetler',
      fileComplaint: 'Şikayette bulunun',
      fileComplaintDescription: 'Şikayette bulunmak için bu formu doldurun',
      send: 'Göndermek',
      reason: 'Sebep',
      details: 'Detaylar',
      complaintFiled: 'Şikayette bulunuldu',
      couldNotFileComplaint: 'Şikayette bulunulamadı: {{error}}',
      placeAnOrder: 'Sipariş ver',
      assignment: 'Atama',
      addStop: 'Durak ekle',
      location: 'Konum',
      date: 'Tarih',
      start: 'Başlangıç',
      stop: 'Durmak',
      weight: 'Ağırlık (kg)',
      volume: 'Hacim (m3)',
      loadMeter: 'Yük ölçer',
      stopsRequired: 'En az 1 durak gerekli',
      contentRequired: 'En az 1 içerik öğesi gerekli',
      truck: 'Kamyon',
      distance: 'Mesafe',
      emissions: 'Emisyonlar',
      sustainability: 'Sürdürülebilirlik',
      attachments: 'Ekler',
      uploadAttachments: 'Ekleri yükle',
      attachmentDeleted: 'Ek silindi',
      couldNotDeleteAttachment: 'Ek silinemedi: {{error}}',
      uploadedAttachment: 'Ek {{document}} yüklendi',
      uploadFailed: '{{document}} eki yüklenemedi: {{error}}',
      route: 'Rota',
      chooseMethod: 'Bir yöntem seçin',
      automatic: 'Otomatik',
      automaticDescription:
        "Bir veya daha fazla taşıma siparişi PDF'si yükleyin; yapay zekamız sipariş ayrıntılarını otomatik olarak çıkaracaktır. Her PDF ayrı bir sipariş haline gelir.",
      manual: 'Manuel',
      manualDescription: 'Sipariş formunu tüm duraklar, kargo ve teslimat ayrıntılarıyla kendiniz doldurun.',
      uploadPdfs: "Taşıma siparişi PDF'lerini yükleyin",
      processingPdf: 'PDF işleniyor...',
      createOrders: 'Sipariş oluştur',
      orderCreated: 'Sipariş oluşturuldu',
      ordersCreated: '{{count}} siparişler oluşturuldu',
      couldNotCreateFromPdf: "PDF'den sipariş oluşturulamadı: {{error}}",
      uploadAtLeastOnePdf: 'En az bir PDF yükleyin',
      viewOrder: 'Siparişi görüntüle',
      creatingOrders: 'Siparişler oluşturuluyor...',
      report: 'Rapor',
      orderPlaced: 'Sipariş verildi',
      couldNotPlaceOrder: 'Sipariş verilemedi: {{error}}',
      stopNumber: 'Durak {{number}} - {{type}}',
      orderLink: 'Sipariş {{orderNumber}} - {{customerRef}}',
    },
    quotes: {
      quotes: 'Alıntılar',
      quote: 'Alıntı',
      quoteReference: 'Teklif referansı',
      quoteDate: 'Teklif tarihi',
      expirationDate: 'Son kullanma tarihi',
      total: 'Toplam',
      search: 'Fiyat teklifi arayın...',
      quotation: 'Alıntı {{reference}}',
      notFound: 'Alıntı bulunamadı',
      departurePlace: 'Kalkış yeri',
      destination: 'Varış noktası',
      distance: 'Mesafe',
      price: 'Fiyat',
      type: 'Tip',
      requests: 'İstenilen fiyat teklifleri',
      request: 'Fiyat teklifi isteyin',
      requestTitle: 'Fiyat teklifi isteği {{reference}}',
      notes: 'Notlar',
      lines: 'Alıntı satırları',
      addLine: 'Satır ekle',
      noLines: 'Alıntı satırı yok',
      requestSuccess: 'Teklif istendi',
      requestFailed: 'Fiyat teklifi istenemedi: {{error}}',
      requestedAt: 'Talep tarihi:',
      quotationRequests: 'Teklif talepleri',
      hasQuote: 'Alıntı var',
      generalInformation: 'Genel bilgi',
      removeLine: 'Satırı kaldır',
    },
    quoteLine: {
      from: 'İtibaren',
      to: 'İle',
    },
    invoices: {
      invoices: 'Faturalar',
      invoiceNumber: 'Fatura numarası',
      invoiceDate: 'Fatura tarihi',
      dueDate: 'Bitiş tarihi',
      total: 'Toplam',
      search: 'Fatura arayın...',
      notFound: 'Fatura bulunamadı',
      invoice: 'Fatura {{invoiceNumber}}',
      structuredComment: 'Yapılandırılmış yorum',
      reference: 'Referans',
      sentAt: 'Gönderildi',
      load: 'Yük',
      unload: 'Boşalt',
      description: 'Tanım',
      amount: 'Miktar',
      unitPrice: 'Birim fiyatı',
      vat: 'KDV',
      extraInformation: 'Ekstra bilgi: {{extraInformation}}',
      orderTotal: 'Sipariş toplamı: € {{total}}',
      totalExclVat: 'KDV hariç toplam:',
      totalVat: 'Toplam KDV:',
      totalInclVat: 'KDV dahil toplam:',
      generalInformation: 'Genel bilgi',
    },
    creditNotes: {
      creditNotes: 'Kredi Notları',
      creditNoteNumber: 'Kredi Notu Numarası',
      creditNoteDate: 'Kredi Dekontu Tarihi',
      dueDate: 'Bitiş tarihi',
      total: 'Toplam',
      search: 'Kredi notu arayın...',
      notFound: 'Kredi Notu bulunamadı',
      creditNote: 'Kredi Notu {{creditNoteNumber}}',
      structuredComment: 'Yapılandırılmış Yorum',
      reference: 'Referans',
      sentAt: 'Gönderildi',
      load: 'Yük',
      unload: 'Boşalt',
      description: 'Tanım',
      amount: 'Miktar',
      unitPrice: 'Birim Fiyatı',
      vat: 'KDV',
      extraInformation: 'Ekstra bilgi: {{extraInformation}}',
      orderTotal: 'Sipariş toplamı: € {{total}}',
      totalExclVat: 'Toplam hariç KDV:',
      totalVat: 'Toplam KDV:',
      totalInclVat: 'Toplam dahil. KDV:',
      generalInformation: 'Genel bilgi',
    },
    businessInformation: {
      businessInformation: 'İşletme Bilgileri',
      updateBusinessInformation: 'İşletme Bilgilerini Güncelle',
      name: 'İsim',
      vatNumber: 'KDV Numarası',
      businessNumber: 'İşletme Numarası',
      saveChanges: 'Değişiklikleri Kaydet',
      informationChanged: 'Bilgiler güncellendi',
      informationNotChanged: 'Bilgiler güncellenemedi: {{error}}',
      requestChanges:
        'Şirket adını, KDV numarasını veya işletme numarasını güncellemek için lütfen bizimle iletişime geçin',
    },
    ourInformation: {
      ourInformation: 'İşletme Bilgileri TransDirect',
      name: 'İsim',
      vatNumber: 'KDV Numarası',
      businessNumber: 'İşletme Numarası',
      address: 'Adres',
      contact: 'Temas etmek',
      phoneNumber: 'Telefon Numarası',
      emailTransport: 'Taşıma E-postası',
      emailAccounting: 'Muhasebe E-postası',
      emailGeneral: 'Genel E-posta',
    },
    contacts: {
      contacts: 'Kişiler',
      name: 'İsim',
      email: 'E-posta',
      phone: 'Telefon',
      function: 'İşlev',
      language: 'Dil',
      notifications: 'Uygun iletişim',
      newContact: 'Yeni kişi',
      contactCreated: 'Kişi oluşturuldu',
      couldNotCreateContact: 'Kişi oluşturulamadı: {{error}}',
      createContact: 'Kişi oluştur',
      notFound: 'Kişi bulunamadı',
      updatedContact: 'Kişi güncellendi',
      couldNotUpdateContact: 'Kişi güncellenemedi: {{error}}',
      updateContact: 'Kişiyi güncelle',
      delete: 'Silmek',
      deleteContact: 'Kişiyi sil',
      deleteContactConfirmation: '{{name}} kişisini silmek istediğinizden emin misiniz?',
      deleteContactError: 'Kişi silinemedi: {{error}}',
      deleteContactSuccess: 'Kişi silindi',
    },
    users: {
      users: 'Kullanıcılar',
      inviteUser: 'Kullanıcıyı Davet Et',
      invitedUsers: 'Davet Edilen Kullanıcılar',
      noInvitedUsers: 'Davet edilen kullanıcı yok',
      removeInvite: 'Daveti Kaldır',
      confirmRemoveInvite: '{{email}} davetiyesini kaldırmak istediğinizden emin misiniz?',
      inviteRemoved: 'Davetiye kaldırıldı',
      couldNotRemoveInvite: 'Davetiye kaldırılamadı: {{error}}',
      noUsersFound: 'Kullanıcı bulunamadı',
      removeUser: 'Kullanıcıyı Kaldır',
      confirmRemoveUser: '{{name}} kullanıcısını kaldırmak istediğinizden emin misiniz?',
      userRemoved: 'Kullanıcı kaldırıldı',
      couldNotRemoveUser: 'Kullanıcı kaldırılamadı: {{error}}',
      active: 'Aktif',
      inactive: 'Etkin değil',
      userInvited: 'Kullanıcı davet edildi',
      couldNotInviteUser: 'Kullanıcı davet edilemedi: {{error}}',
      name: 'İsim',
      email: 'E-posta',
      isActive: 'Aktif mi?',
      invited: 'Davet edildi',
    },
    cmrReminder: {
      cmrReminder: 'CMR Hatırlatma',
      sendReminder: 'Göndermek',
      confirmText: 'CMR hatırlatıcısı göndermek istediğinizden emin misiniz?',
      confirmation: 'CMR Hatırlatıcısı gönderildi',
      error: 'CMR hatırlatıcısı gönderilemedi: {{error}}',
    },
    sustainability: {
      sustainability: 'Sürdürülebilirlik',
      policy: 'Sürdürülebilirlik Politikası',
      viewOverview: 'Sürdürülebilirliğe genel bakışı görüntüleyin',
      orderCount: 'Sipariş sayısı',
      totalDistance: 'Toplam mesafe',
      totalWeight: 'Toplam ağırlık',
      totalEmissions: 'Toplam CO2 emisyonları',
      averageDistance: 'Ortalama mesafe',
      averageWeight: 'Ortalama ağırlık',
      averageEmissions: 'Ortalama CO2 emisyonları',
      total: 'Toplam',
      avgPerOrder: 'Sipariş başına ortalama',
    },
    settings: {
      settings: 'Ayarlar',
    },
    apiKeys: {
      apiKeys: 'API Anahtarları',
      createApiKey: 'API Anahtarı Oluştur',
      name: 'İsim',
      scopes: 'İzinler',
      status: 'Durum',
      lastUsed: 'Son kullanılan',
      createdAt: 'Oluşturulma tarihi:',
      prefix: 'Önek',
      active: 'Aktif',
      revoked: 'İptal edildi',
      expired: 'Günü geçmiş',
      never: 'Asla',
      revokeApiKey: 'API Anahtarını İptal Et',
      confirmRevoke: '" {{name}} " API anahtarını iptal etmek istediğinizden emin misiniz? Bu geri alınamaz.',
      apiKeyRevoked: 'API anahtarı iptal edildi',
      couldNotRevoke: 'API anahtarı iptal edilemedi: {{error}}',
      apiKeyCreated: 'API anahtarı oluşturuldu',
      couldNotCreate: 'API anahtarı oluşturulamadı: {{error}}',
      copyKey: 'Anahtarı kopyala',
      keyCopied: 'Anahtar kopyalandı',
      keyWarning: 'Bu anahtarı güvenli bir şekilde saklayın. Bir daha gösterilmeyecek.',
      noApiKeys: 'API anahtarı bulunamadı',
      ordersRead: 'Siparişleri oku',
      ordersWrite: 'Sipariş oluştur',
      maxKeysReached: 'Maksimum API anahtarı sayısına ulaşıldı',
      scopeRequired: 'En az bir kapsam gereklidir',
    },
    loading: 'Yükleniyor...',
  },
  liveTracking: {
    title: 'Takip',
    subtitle: 'Bu kamyonun konumu ve yol bilgisayarı.',
    loading: 'Konum alınıyor…',
    noPosition: 'Bu kamyon için henüz konum bilinmiyor.',
    noPositionHint: 'Entegrasyon sayfasında bu plakaya bir araç bağlayın.',
    noConnection: 'Bu kamyonu henüz takip eden bir bağlantı yok. Konumunu görmek için bir bağlantı ekleyin.',
    driving: 'Hareket ediyor',
    idle: 'Duruyor',
    location: 'Konum',
    speed: 'Hız',
    heading: 'Yön',
    odometer: 'Kilometre sayacı',
    fuel: 'Yakıt',
    lastMeasurement: 'Son ölçüm',
    liveActive: 'Canlı takip açık — her 30 saniyede yenilenir.',
    lastSignal: 'Son sinyal',
    trailer: 'Römork',
    refresh: 'Yenile',
    startLive: 'Canlı takibi başlat',
    stopLive: 'Canlı takibi durdur',
    resizePanel: 'Yan paneli yeniden boyutlandır',
    connections: 'Takip bağlantıları',
    connectionsSubtitle: 'Kamyonlarını takip etmek için bir tedarikçinin takip ortamını bağlayın.',
    addConnection: 'Takip bağlantısı ekle',
    integrations: 'Takip entegrasyonları',
    integrationsHint: 'Bir tedarikçinin takibini bağlamak için bir sağlayıcı seçin.',
    providerFleetmaster: 'Kamyonların konumunu ve yol bilgisayarını FleetMaster.lt üzerinden takip edin.',
    connectionLabel: 'Ad',
    connectionLabelHelp: 'Bu bağlantının listede nasıl görüneceği.',
    helpCompanyId: 'FleetMaster telematik hesabınızdaki şirket kimliği.',
    helpSuivoBaseUrl: 'Standart Suivo ortamı için boş bırakın.',
    ownerLabel: 'Tedarikçi kimliği',
    ownerHelp: 'Bir taşeron/tedarikçiye ait bağlantı için.',
    credentialsNote: 'Anahtar şifrelenmiş olarak saklanır ve kaydettikten sonra bir daha gösterilmez.',
    connect: 'Bağla',
    back: 'Geri',
    noConnections: 'Henüz takip bağlantısı yok.',
    noConnectionsHint: 'Kamyonların nerede olduğunu görmek için bir tane ekleyin.',
    moreConnectionsTitle: 'Daha fazla takip bağlantısı yakında',
    moreConnectionsBody:
      'FleetMaster ilk sağlayıcıdır. Daha fazla takip bağlantısı üzerinde çalışıyoruz — yeni sağlayıcılar burada otomatik olarak görünür.',
    connectionsLoading: 'Bağlantılar alınıyor…',
    vehiclesLoading: 'Araçlar alınıyor…',
    noVehicles: 'Bu bağlantı henüz araç bildirmiyor.',
    statusActive: 'Etkin',
    statusError: 'Hata',
    keyLabel: 'anahtar',
    linkedCount: '{{total}} aracın {{linked}} tanesi bağlandı',
    lastChecked: 'son kontrol',
    never: 'asla',
    supplierOwner: 'Tedarikçi #{{id}}',
    connectionSettings: 'Bağlantı ayarları',
    verify: 'Kontrol et',
    verifyOk: 'Bağlantı çalışıyor.',
    verifyFailed: 'Bağlantı kontrol edilemedi.',
    remove: 'Sil',
    removeTitle: 'Bağlantıyı sil',
    removeDescription: '"{{label}}" bağlantısı ve kayıtlı anahtar silinecek.',
    connectionRemoved: 'Bağlantı silindi.',
    linkVehicles: 'Araçları bağla',
    linkVehiclesHint: 'Bir araç seçin, ardından içinde çalıştığı kamyonu seçin.',
    link: 'Bağla',
    unlink: 'Bağlantıyı kaldır',
    linkTruck: 'Kamyonu bağla',
    chooseTruck: 'Kamyon',
    chooseTruckHelp: 'Bu aracın içinde gittiği kamyonu seçin.',
    chooseTruckRequired: 'Bir kamyon seçin',
    moreTrucks: 'Yalnızca ilk {{count}} kamyon gösteriliyor — listeyi daraltmak için arama yapın.',
    plateMatch: 'plaka eşleşiyor',
    linkedTo: '{{truck}} ile bağlı',
    linkedManually: 'manuel',
    notLinked: 'Bağlı değil',
    vehicleLinked: 'Araç bağlandı.',
    vehicleUnlinked: 'Bağlantı kaldırıldı.',
    trailerSubtitle: 'Bu römorkun konumu.',
    linkTracker: 'Takip cihazını bağla',
    linkTrackerHint: 'Bu römorkta bulunan aracı seçin.',
    linkTrailer: 'Römorku bağla',
    linkTrailerHint: 'Bir araç, ardından üzerinde bulunduğu römorku seçin.',
    chooseTrailer: 'Römork',
    chooseTrailerRequired: 'Bir römork seçin',
    noTrackerLinked: 'Bu römorka henüz bir takip cihazı bağlı değil — konumu görmek için birini bağlayın.',
    noTrailerPosition: 'Bu römork için henüz konum bilinmiyor.',
    searchUnits: 'Ada veya plakaya göre ara…',
    noUnits: 'Henüz araç bildirilmedi.',
    providerSuivo: 'Treylerlerimizin konumunu Suivo takip cihazlarıyla izleyin.',
    ownerKindLabel: 'Sahip',
    ownerKindCompany: 'Kendi filomuz (şirket)',
    ownerKindCarrier: 'Taşıyıcı/tedarikçi',
    supplierOwnerCompany: 'Kendi filomuz',
    status: {
      moving: 'Hareket halinde',
      parked: 'Park hâlinde',
      idling: 'Rölantide',
      immobilized: 'Bloke',
      offline: 'Sinyal yok',
      inOperation: 'Çalışıyor',
    },
    trailersMap: {
      searchLabel: 'Ara (TDR kimliği / ad / plaka)',
      searchPlaceholder: 'Ad veya plakaya göre ara...',
      trackerLabel: 'Takip cihazı',
      trackerAll: 'Tüm dorseler',
      trackerTracked: 'Takip cihazlı',
      trackerUntracked: 'Takip cihazsız',
      trackerSilent: '24 saatten fazla sinyal yok',
      tableCardTitle: 'Dorseler',
      mapCardTitle: 'Harita',
      tableTrailer: 'Dorse',
      tablePlate: 'Plaka',
      tableTracker: 'Takip cihazı',
      tableStatus: 'Durum',
      tableLastSignal: 'Son sinyal',
      tablePlace: 'Konum',
      noTracker: 'Takip cihazı yok',
      clearFilters: 'Tüm filtreleri temizle',
      noneTrackedTitle: 'Henüz takip cihazı bağlanmadı',
      noneTrackedDescription: 'Haritada görmek için bir Suivo ünitesini bir dorseye bağlayın.',
      noneInFilter: 'Bu seçimde dorse yok',
      noConnectionsTitle: 'Henüz takip bağlantısı yok',
      noConnectionsDescription: 'Dorselerimizin nerede olduğunu görmek için bir bağlantı ekleyin.',
      noConnectionsAction: 'Takip entegrasyonlarına git',
      connectionErrorTitle: 'Hatalı takip bağlantısı',
    },
  },
  carrierPortal: {
    liveTracking: { liveTracking: 'Takip' },
    selectCarrier: 'Taşıyıcı seçin',
    loading: 'Yükleniyor...',
    switch: 'Taşıyıcı değiştir',
    home: {
      carrierPortal: 'Taşıyıcı Portalı',
      title: 'Taşıyıcı Portalı',
      hello: 'Merhaba,',
      welcome: 'Taşıyıcı portalına hoş geldiniz.',
      manageOrders: 'Tüm taşıma siparişlerinizi yönetin.',
      managePlanning: 'Planlamanızı yönetin.',
      selfBilling: 'Otomatik faturalandırma faturalarınızı oluşturun ve yönetin.',
      info: 'Bilgi',
      infoSubtitle: 'TransDirect ve taşıyıcı portalı hakkında bilgiler',
      contact: 'İlgili kişi',
      contactSubtitle: 'TransDirect irtibat kişiniz kim?',
      FuelCard: 'Yakıt Kartı',
      FuelCardSubtitle: 'Kişiselleştirilmiş TransDirect yakıt kartınızı isteyin',
      saveChanges: 'Değişiklikleri kaydet',
    },
    orders: {
      allAccepted: 'Tüm siparişler onaylandı',
      customerReference: 'Müşteri referansı',
      draft: 'Taslak',
      load: 'Yük',
      orders: 'Siparişler',
      manageOrders: 'Tüm taşımalarınızı yönetin ve taşıma belgelerinizi yükleyin',
      orderRef: 'TD-Referansı',
      loadLocation: 'Yükleme Konumu',
      unload: 'Boşalt',
      unloadLocation: 'Boşaltma Konumu',
      invoiceTotal: 'Navlun Oranı',
      hasCMR: 'Belgeleri var',
      documents: 'Belgeler',
      cmrRejected: 'Reddedildi',
      cmrPending: 'İşlemde',
      cmrUploadHint: 'Bir veya birden fazla PDF yükleyebilirsiniz; bunları tek bir belge olarak birleştiririz.',
      cmrUploaded: 'Belge yüklendi',
      cmrUploadFailed: 'Belge yüklenemedi: {{error}}',
      documentValidation: 'Belgeler',
      documentValidationNoDocuments: 'Belge yok',
      documentValidationPending: 'İşlemde',
      documentValidationApproved: 'Onaylandı',
      documentValidationRejected: 'Reddedildi',
      outstandingDocsTitle: 'Hâlâ teslim edilmesi gereken belgeler',
      requiredDocMissing: 'eksik',
      requiredDocInReview: 'inceleniyor',
      requiredDocRejected: 'reddedildi — lütfen yeniden yükleyin',
      requiredDocStatusReceived: 'Alındı',
      requiredDocStatusInReview: 'İncelemede',
      requiredDocStatusRejected: 'Reddedildi',
      requiredDocStatusMissing: 'Eksik',
      requiredDocsTitle: 'Zorunlu belgeler',
      requiredDocsSubtitle: 'Bu müşteri bu sipariş için aşağıdaki belgeleri talep ediyor.',
      requiredDocsProgress: '{{done}} / {{total}} alındı',
      requiredDocReupload: 'Yeniden yükle',
      uploadDocumentTitle: '{{document}} yükle',
      uploadRequiredDoc: 'Yükle',
      uploadDocumentsTitle: 'Belge yükle',
      uploadDocumentsHint:
        'Bir veya birden fazla dosyayı aynı anda yükleyin; bunları ayırıp her parçayı doğru belge türüne bağlarız.',
      docReasonInReview: 'inceleniyor',
      docReasonRejected: 'reddedildi',
      docRejectionLowQuality: 'okunaksız',
      docRejectionMissingSignature: 'imza eksik',
      docRejectionNoOrderReference: 'referans bulunamadı',
      docRejectionNotNeutral: 'nötr olmayan CMR',
      docRejectionWrongCustomer: 'yanlış müşteri',
      docRejectionWrongDeliveryAddress: 'yanlış teslimat adresi',
      docRejectionWrongDocumentType: 'yanlış belge türü',
      docRejectionWrongOrgOnDocument: 'yanlış şirket',
      requiredDocUploaded: 'Belge yüklendi',
      requiredDocUploadFailed: 'Belge yüklenemedi: {{error}}',
      purchases: 'Navlun Oranı',
      reference: 'Referans',
      assignee: 'Atandı',
      orderAssigned: 'Sipariş atandı',
      changeAssignee: 'Değiştirmek',
      assignOrder: 'Sipariş Ata',
      assign: 'Atamak',
      route: 'Rota',
      error: 'Hata',
      report: 'Rapor',
    },
    planning: {
      acceptAll: 'Tümünü kabul et',
      actions: 'Eylemler',
      date: 'Tarih',
      loadingOrders: 'Siparişler yükleniyor...',
      noTruck: 'Bu taşıyıcının henüz bir kamyonu yok.',
      ordersForTruck: '{{licensePlate}} plakalı kamyon siparişleri',
      planning: 'Planlama',
      truck: 'Kamyon',
      managePlanning: 'Taşıma planlamanızı görüntüleyin ve yönetin',
    },
    selfBilling: {
      selfBilling: 'Otomatik Faturalandırma',
      rideOverview: 'Sefer özeti',
      manageRideOverview: 'Sefer özetlerinizi görüntüleyin ve indirin',
      searchRideOverviewPlaceholder: 'Sefer özeti arayın...',
      type: 'Tür',
      number: 'Numara',
      manageSelfBilling: 'Otomatik Faturalandırmanızı görüntüleyin ve indirin',
      searchPlaceholder: 'Otomatik faturalandırmayı arayın...',
      id: 'Referans',
      date: 'Tarih',
      download: 'İndirmek',
      invoice: 'Fatura',
      title: 'Kendi Kendine Faturalandırma Faturası',
    },
    generalInformation: {
      generalInformation: 'Bilgi',
      noDocumentsAvailable: 'Belge yok',
      checkBackLater: 'Güncellenmiş belgeler için daha sonra tekrar kontrol edin',
    },

    businessInformation: {
      businessInformation: 'İşletme Bilgileri',
      settingsAndBusinessInformation: 'Ayarlar ve İşletme Bilgileri',
      tabGeneral: 'Genel',
      tabFleet: 'Filo',
      tabContacts: 'Kişiler',
      civilLiabilityInsurance: 'Hukuki Sorumluluk Sigortası',
      CMRInsurance: 'CMR Sigortası',
      transportationInsurance: 'Nakliye Sigortası',
      documentUploaded: 'Belge yüklendi',
      insurances: 'Sigortalar',
    },
    contacts: {
      contacts: 'Kişiler',
      newContact: 'Yeni Kişi',
      updateContact: 'Kişiyi Kaydet',
      name: 'İsim',
      email: 'E-posta',
      phone: 'Telefon',
      function: 'İşlev', // Or 'Role' could be used depending on context
      language: 'Dil',
      delete: 'Silmek',
      createContactSuccess: 'Kişi başarıyla oluşturuldu',
      createContactError: 'Kişi oluşturulurken hata oluştu: {{error}}',
      updateContactSuccess: 'Kişi başarıyla güncellendi',
      updateContactError: 'Kişi güncellenirken hata oluştu: {{error}}',
      deleteContact: 'Kişiyi Sil',
      deleteContactConfirmation: 'Kişinizi silmek istediğinizden emin misiniz?',
      deleteContactSuccess: 'Kişi başarıyla silindi',
      deleteContactError: 'Kişi silinirken hata oluştu: {{error}}',
      notFound: 'Kişi bulunamadı',
      notifications: 'Bildirimler',
    },
    trucks: {
      title: 'Kamyonlar',
      newTruck: 'Yeni Kamyon',
      update: 'Kamyonu Güncelle',
      licensePlate: 'Plaka',
      codeName: 'Kod adı',
      planner: 'Planlayıcı',
      isActive: 'Aktif',
      insuranceExpiresAt: 'Sigortanın süresi doluyor',
      examinationExpiresAt: 'Muayene şu tarihte sona eriyor:',
      documents: 'Belgeler',
      yes: 'Evet',
      no: 'HAYIR',
      moveUp: 'Yukarı Taşı',
      moveDown: 'Aşağı Taşı',
      create: 'Yaratmak',
      succeeded: 'Kamyon kaydedildi',
      createError: 'Kamyon oluşturulamadı:',
      updateError: 'Kamyon güncellenemedi:',
      insurance: 'Sigorta',
      insuranceUploaded: 'Sigorta kaydedildi',
      examination: 'Denetleme',
      examinationUploaded: 'İnceleme kaydedildi',
      notFound: 'Kamyon bulunamadı',
      appLoginTitle: 'Sürücü uygulaması girişi',
      appLoginHint:
        'Sürücüler plaka ile giriş yapar. Şifreyi buradan ayarlayın; sürücüler kendi şifrelerini sıfırlayamaz.',
      appPasswordLabel: 'Sürücü uygulaması şifresi',
      appLoginLabel: 'Giriş (plaka)',
      appCodeNameLabel: 'Kod adı',
      appSavePassword: 'Şifreyi kaydet',
      appDisableLogin: 'Girişi devre dışı bırak',
      appPasswordSaved: 'Şifre kaydedildi',
      appLoginDisabled: 'Sürücü uygulaması girişi devre dışı bırakıldı',
      detailsTitle: 'Çekici bilgileri',
      documentCount: '{{total}} içinden {{count}}',
      statusValid: 'Geçerli',
      statusExpiringSoon: 'Yakında sona eriyor',
      statusExpired: 'Süresi doldu',
      statusMissing: 'Eksik',
      expiresOn: '{{date}} tarihinde sona eriyor',
      noDocument: 'Henüz belge yüklenmedi',
      viewDocument: 'Görüntüle',
      replaceDocument: 'Değiştir',
      uploadDocument: 'Yükle',
      searchPlaceholder: 'Plakaya göre ara…',
      noExpiryKnown: 'Son kullanma tarihi bilinmiyor',
      notUploadedYet: 'Henüz yüklenmedi',
    },
    trailers: {
      title: 'Fragmanlar',
      truckAmount: 'Kamyon sayısı',
      tautlinerAmount: 'Gerdirme sayısı',
      boxTrailerAmount: 'Kapalı kasa/frigo römork sayısı',
      openTrailerAmount: 'Açık römork sayısı',
      save: 'Değişiklikleri kaydet',
      saveSuccess: 'Taşıyıcı güncellendi',
      saveError: 'Taşıyıcı güncellenemedi: {{error}}',
      subtitle: 'Türe göre adetler — kapasite planlaması için',
    },
    driverBlock: {
      title: 'Sürücü erişimi',
      message: 'Siparişlerinizi görüntülemek için lütfen cep telefonunuzdaki sürücü uygulamasına giriş yapın.',
    },
    notFound: {
      pageNotFound: 'Sayfa bulunamadı.',
      pageNotFoundDesc:
        'Bu sayfa (henüz) mevcut görünmüyor. Bir şeylerin yanlış olduğunu düşünüyorsanız lütfen TransDirect irtibat kişinizle iletişime geçin.',
    },
    invite: {
      title: 'Taşıyıcı Portalına Davet Edildi',
      details: 'TransDirect taşıyıcı portalına davet edildiniz, şifrenizi girerek hesabınızı oluşturun.',
      accepted: 'Davet kabul edildi, kısa süre içinde ana sayfaya yönlendirileceksiniz.',
      acceptError: 'Davet kabul edilemedi: {{error}}',
      acceptButtonText: 'Daveti Kabul Et',
      password: 'Şifre',
      repeatPassword: 'Şifreyi tekrar girin',
    },
    users: {
      users: 'Kullanıcılar',
      inviteUser: 'Kullanıcıyı Davet Et',
      invitedUsers: 'Davet Edilen Kullanıcılar',
      noInvitedUsers: 'Davet edilen kullanıcı yok',
      removeInvite: 'Daveti Kaldır',
      confirmRemoveInvite: '{{email}} davetiyesini kaldırmak istediğinizden emin misiniz?',
      inviteRemoved: 'Davetiye kaldırıldı',
      couldNotRemoveInvite: 'Davetiye kaldırılamadı: {{error}}',
      noUsersFound: 'Kullanıcı bulunamadı',
      removeUser: 'Kullanıcıyı Kaldır',
      confirmRemoveUser: '{{name}} kullanıcısını kaldırmak istediğinizden emin misiniz?',
      userRemoved: 'Kullanıcı kaldırıldı',
      couldNotRemoveUser: 'Kullanıcı kaldırılamadı: {{error}}',
      active: 'Aktif',
      inactive: 'Etkin değil',
      userInvited: 'Kullanıcı davet edildi',
      couldNotInviteUser: 'Kullanıcı davet edilemedi: {{error}}',
      name: 'İsim',
      email: 'E-posta',
      isActive: 'Aktif mi?',
      role: 'Rol',
      roleDispatcher: 'Sevk görevlisi',
      roleDriver: 'Sürücü',
      activeUsers: 'Aktif Kullanıcılar',
      pendingInvitations: 'Bekleyen Davetiyeler',
      sendInvitation: 'Davetiye Gönder',
      sending: 'Gönderiliyor...',
      cancel: 'İptal etmek',
      emailAddress: 'E-posta Adresi',
      deleteInvitation: 'Daveti Sil',
      joined: 'Katıldı',
      invited: 'Davet edildi',
      assignee: 'Vekil',
      assignOrder: 'Sipariş Ata',
      unassigned: 'Atanmamış',
      assignedTo: 'Atandı',
      roleUpdated: 'Rol güncellendi',
      renameUser: 'Kullanıcıyı Yeniden Adlandır',
      newName: 'Yeni isim',
      userRenamed: 'Kullanıcı yeniden adlandırıldı',
      save: 'Kaydetmek',
      permissions: 'İzinler',
      canRenameUsers: 'Kullanıcıları yeniden adlandırabilir',
      permissionsUpdated: 'İzinler güncellendi',
      nameOptional: 'Ad (isteğe bağlı)',
      emailRequired: 'Lütfen bir e-posta adresi girin',
      namePlaceholder: 'Ahmet Yılmaz',
      emailPlaceholder: 'kullanici@ornek.com',
    },
    tracking: {
      loading: 'İzleme etkinlikleri yükleniyor...',
      events: 'Etkinlikleri Takip Etme',
      noEvents: 'İzleme etkinliği bulunamadı',
      scheduled: 'planlanmış',
      eventTypes: {
        StatusLoaded: 'Yüklendi',
        StatusUnloaded: 'Boşaltılmış',
        LocationPing: 'Konum güncellemesi',
      },
      stop: 'Durmak',
      by: 'ile',
    },
  },
  carrierContactNotifications: {
    transportOrders: 'Taşıma Siparişleri',
    selfBillings: 'Kişisel Faturalandırma',
  },
  orderStatus: {
    Draft: 'Taslak',
    Created: 'Oluşturuldu',
    Prepayment: 'Ön ödeme',
    Placed: 'Yerleştirildi',
    Confirmed: 'Onaylandı',
    Refused: 'Reddedildi',
    Executed: 'Uygulanmış',
    Cancelled: 'İptal edildi',
  },
  orderSaleStatus: {
    Created: 'Oluşturuldu',
    Credited: 'Kredilendirildi',
    Incomplete: 'Tamamlanmamış',
    Invoiced: 'Faturalandı',
  },
  customerContactNotifications: {
    invoice: 'Fatura',
    orderConfirmation: 'Sipariş Onayı',
    cmr: 'CMR',
    quotation: 'Alıntı yapmak',
    dieselSurcharge: 'Dizel Ek Ücreti',
    paymentReminder: 'Ödeme Hatırlatıcısı',
  },
  errors: {
    required: 'Gerekli',
    invalidEmail: 'Geçersiz e-posta',
    dateShouldBeInTheFuture: 'Tarih gelecekte olmalıdır',
    startTimeShouldBeBeforeEndTime: 'Başlangıç ​​zamanı bitiş zamanından önce olmalıdır',
    passwordsDontMatch: 'Şifre ve tekrar şifre eşleşmiyor.',
    passwordTooShort: 'Şifre çok kısa.',
    formValidation: 'Lütfen formdaki işaretli alanları kontrol edin',
    retry: 'Tekrar dene',
    reloadPage: 'Sayfayı yenile',
    networkTitle: 'Bağlantı sorunu',
    networkDescription: 'Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edip tekrar deneyin.',
    serverTitle: 'Sunucu hatası',
    serverDescription: 'Sunucu isteğinizi işleyemedi. Lütfen daha sonra tekrar deneyin.',
    notFoundTitle: 'Bulunamadı',
    notFoundDescription: 'İstenen veriler artık mevcut değil veya kullanılamıyor.',
    sessionTitle: 'Oturum süresi doldu',
    sessionDescription: 'Oturumunuz sona erdi veya giriş yapmadınız. Devam etmek için tekrar giriş yapın.',
    permissionTitle: 'Erişim yok',
    permissionDescription: 'Bu verilere erişiminiz yok.',
    validationTitle: 'Geçersiz veri',
    validationDescription: 'Girilen verileri kontrol edip tekrar deneyin.',
    rateLimitTitle: 'Çok fazla istek',
    rateLimitDescription: 'Çok fazla istek gönderildi. Biraz bekleyip tekrar deneyin.',
    abortedTitle: 'İstek iptal edildi',
    abortedDescription: 'İstek iptal edildi. Gerekirse tekrar deneyin.',
    unknownTitle: 'Bilinmeyen hata',
    unknownDescription: 'Beklenmeyen bir hata oluştu. Tekrar deneyin veya sorun devam ederse destekle iletişime geçin.',
    loadingTitle: 'Yükleme başarısız',
    loadingDescription: 'Veriler yüklenemedi.',
  },
  orderComplaintType: {
    Aggression: 'Fiziksel/Sözlü saldırganlık',
    DamagedGoods: 'Hasarlı mallar',
    IncorrectDelivery: 'Yanlış teslimat',
    IncorrectInvoice: 'Yanlış fatura',
    LateDelivery: 'Geç teslimat',
    Other: 'Diğer',
  },
  myProfile: {
    myProfile: 'Profilim',
    logout: 'Oturumu kapat',
    name: 'İsim',
    role: 'Rol',
    email: 'E-posta',
    language: 'Dil',
    languageChanged: 'Dil güncellendi',
    languageNotChanged: 'Dil güncellenemedi: {{error}}',
    joinedAt: 'Katılma tarihi:',
    nameChanged: 'İsim güncellendi',
    nameNotChanged: 'Ad güncellenemedi: {{error}}',
  },
  auth: {
    forgotPassword: {
      title: 'Parolanızı mı unuttunuz',
      requestNewPassword: 'Yeni Şifre İste',
      instructions:
        'E-postanızı girin, eğer kullanıcı sistemde mevcutsa, yakında yeni şifre belirlemeniz için bir e-posta alacaksınız.',
      requestFailed: 'Yeni şifre istenemedi',
      instructionsSent: 'Yeni şifre belirleme talimatları e-posta adresinize gönderildi.',
    },
    configNewPassword: {
      title: 'Yeni Şifre Belirle',
      newPassword: 'Yeni Şifre',
      repeatNewPassword: 'Yeni Şifreyi Tekrarla',
      confirmButtonText: 'Yeni Şifre Belirle',
      passwordDontMatch: 'Şifre ve tekrar şifresi eşleşmelidir',
      tokenNotFound: 'Jeton bulunamadı',
      invalidToken: 'Jeton artık geçerli değil',
      configFailed: 'Şifre ayarlanamadı: {{error}}',
    },
    login: {
      login: 'Giriş yapmak',
      email: 'E-posta',
      password: 'Şifre',
      forgotPassword: 'Parolanızı mı unuttunuz',
      customerLoginTitle: 'Müşteri Girişi',
      loginWithGoogle: 'Google ile giriş yap',
      incorrectCredentials: 'E-posta veya şifre yanlış',
      loginFailed: 'Giriş yapılamadı: {{error}}',
    },
    userNotFound: {
      title: 'Kullanıcı Bulunamadı',
      description: 'Oturum açılamadı, bir hata oluştu veya kullanıcı artık mevcut değil.',
      goToLoginPage: 'Giriş Sayfasına Git',
    },
  },
  upload: {
    title: 'Yüklemek',
    dropzoneHint: 'Yüklemek için buraya tıklayın veya dosya(ları) kutuya sürükleyin',
    uploadDocuments: 'Belgeleri yükleyin',
    confirmDeleteDocument: 'Bu belgeyi silmek istediğinizden emin misiniz?',
    deleteDocument: 'Belgeyi sil',
    noDocumentsFound: 'Hiçbir belge bulunamadı',
    noDocumentsSelected: 'Hiçbir belge seçilmedi',
    uploadFailed: 'Belge yüklenemedi',
    uploadDocumentFailed: '{{filename}} dosyası yüklenemedi: {{reason}}',
    multiUploadFailed: 'Dosyalar yüklenemedi: {{reason}}',
  },
  or: 'veya',
  draft: 'Taslak',
  cancel: 'İptal etmek',
  close: 'Kapalı',
  moreInfo: 'Daha fazla bilgi',
  previous: 'Öncesi',
  next: 'Sonraki',
  delete: 'Silmek',
  save: 'Kaydetmek',
  download: {
    open: 'Aç',
    download: 'İndirmek',
    started: 'İndirme başladı',
    failed: 'İndirme başarısız oldu: {{message}}',
  },
  chat: {
    title: 'Sohbet',
    sendMessage: 'Mesaj gönder',
    placeholder: 'Bir mesaj yazın...',
    noMessages: 'Henüz mesaj yok',
    loadMore: 'Daha fazla mesaj yükle',
    messageSent: 'Mesaj gönderildi',
    messageError: 'Mesaj gönderilemedi: {{error}}',
    newMessage: '{{name}}: {{orderNumber}} siparişinde yeni mesaj',
    internal: 'Dahili',
    carrier: 'Taşıyıcı',
  },
};
